export const PATIENT_PROTOCOL_VALIDATION_MESSAGE = {
  FREQUENCY: 'Value for Frequency must match an option in dropdown.',
  TYPE: 'Value for Type must match an option in dropdown.',
};
